import { render, staticRenderFns } from "./dataAlarm.vue?vue&type=template&id=ce64d4e6&scoped=true&"
import script from "./dataAlarm.vue?vue&type=script&lang=js&"
export * from "./dataAlarm.vue?vue&type=script&lang=js&"
import style0 from "./dataAlarm.vue?vue&type=style&index=0&id=ce64d4e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce64d4e6",
  null
  
)

export default component.exports